import { ca } from '@cian/analytics';

import { TPlatform } from '../../../types/platform';
import { MOBILE_CAMPAIGN } from '../DailyrentReviewModalContainer';

const PlatformMap: Record<TPlatform, string> = {
  ios: 'app_iOS',
  android: 'app_android',
  desktop: 'desktop',
  other: 'other',
};

export const trackBannerShow = (platform: TPlatform) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'show_sopr',
    category: 'Install_app_banner',
    label: PlatformMap[platform],
    page: {
      extra: { bannerName: MOBILE_CAMPAIGN },
    },
  });
};

export const trackBannerClick = (platform: TPlatform) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'Install_app_banner',
    label: platform === 'ios' ? 'app_iOS' : 'app_android',
    page: {
      extra: { bannerName: MOBILE_CAMPAIGN },
    },
  });
};
